import React, { useEffect, useState, useRef } from "react";
import * as WebDataRocksReact from "@webdatarocks/react-webdatarocks";
import { post } from "../../services/api";
// import { getRegistrationData } from './services/reportService';

const params = {
  FromDate: "2025-01-01",
  ToDate: "2025-12-31",
  Code: "",
};

const pivotConfig = {
    dataSource: {
        data: []
    },
    options: {
        grid: {
            type: "compact",
        },
    },
    slice: {
        "rows": [
            {
                "uniqueName": "Measures"
            }
        ],
        "columns": [
            {
                "uniqueName": "Center"
            },
            {
                "uniqueName": "Session"
            },
            {
                "uniqueName": "Gender"
            }
        ],
        "measures": [
            {
                "uniqueName": "IsSubmit",
                "aggregation": "sum"
            },
            {
                "uniqueName": "IsInterviewScheduled",
                "aggregation": "sum"
            },
            {
                "uniqueName": "IsInterviewTaken",
                "aggregation": "sum"
            },
            {
                "uniqueName": "IsAccepted",
                "aggregation": "sum"
            },
            {
                "uniqueName": "IsAssessmentAdded",
                "aggregation": "sum"
            },
            {
                "uniqueName": "IsAccountApproved",
                "aggregation": "sum"
            },
            {
                "uniqueName": "IsCEOApproved",
                "aggregation": "sum"
            }
        ],
        "sorting": {
            "row": {
                "type": "desc",
                "tuple": [],
                "measure": "IsSubmit"
            }
        },
        "expands": {
            "columns": [
                {
                    "tuple": [
                        "Center.CL1-Nun"
                    ]
                },
                {
                    "tuple": [
                        "Center.CL1-Nun",
                        "Session.2016-2017"
                    ]
                }
            ]
        },
    }
};

function GetRegistrationData() {
  const [report, setReport] = useState(pivotConfig);
  const [loading, setLoading] = useState(true);
  const pivotRef = useRef(null);
  const token = localStorage.getItem("token");

  const getRegistrationsReportData = async () => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    try {
      const response = await post(`ReportCenter/GetRegistrationData`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      debugger;
      const config = {
        ...pivotConfig,
        dataSource: {
          ...pivotConfig.dataSource,
          data: response.records || []
        },
      };
      setReport(config);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching:", error);
    }
  };

  useEffect(() => {
    getRegistrationsReportData();
  }, []);

  function customizeToolbar(toolbar) {
    let tabs = toolbar.getTabs();
    const excludeTabs = ["wdr-tab-open", "wdr-tab-save", "wdr-tab-connect"];
    toolbar.getTabs = function () {
      tabs = tabs.filter((tab) => !excludeTabs.includes(tab.id));
      return tabs;
    };
  }

  if (loading || !report) return <div>Loading...</div>;

  return (
    <WebDataRocksReact.Pivot
      ref={pivotRef}
      toolbar={true}
      report={report}
      beforetoolbarcreated={customizeToolbar}
      reportcomplete={() => {
        if (pivotRef.current) {
          debugger;
          console.log(
            "Pivot report:",
            pivotRef.current.webdatarocks.getReport()
          );
        }
      }}
    />
    // <WebDataRocksReact.Pivot toolbar={true} />
  );
}

export default GetRegistrationData;
